// project import
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';


// ==============================|| DRAWER HEADER ||============================== //

interface Props {
  open: boolean;
}

const DrawerHeader = ({ open }: Props) => {

  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '60px',
        width: 'inherit',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: open ? '24px' : 0
      }}
    >
      <Logo isIcon={!open} iconProps={{style: {height: 35}}} isWhite />
    </DrawerHeaderStyled>
  );
};

export default DrawerHeader;
